<script setup>
import AdvancedDatabaseManager from '@/views/apps/databaseConnectionData/list/AdvancedDatabaseConnectionDataManager.vue'

const widgetData = ref([
  {
    title: 'Total Databases',
    value: '50',
    change: 10,
    desc: 'Total Databases',
    icon: 'tabler-database',
    iconColor: 'primary',
  },
  {
    title: 'Active Databases',
    value: '45',
    change: 8,
    desc: 'Active Databases',
    icon: 'tabler-database-check',
    iconColor: 'success',
  },
  {
    title: 'Inactive Databases',
    value: '5',
    change: -2,
    desc: 'Inactive Databases',
    icon: 'tabler-database-off',
    iconColor: 'error',
  },
])

definePage({
  meta: {
    action: 'read',
    subject: 'databaseconnectiondatas',
  },
})
</script>

<template>
  <section>
    <!-- 👉 Widgets -->
    <!-- <div class="d-flex mb-6">
      <VRow>
        <template v-for="(data, id) in widgetData" :key="id">
          <VCol cols="12" md="3" sm="6">
            <VCard>
              <VCardText>
                <div class="d-flex justify-space-between">
                  <div class="d-flex flex-column gap-y-1">
                    <div class="text-body-1 text-high-emphasis">
                      {{ data.title }}
                    </div>
                    <div class="d-flex gap-x-2 align-center">
                      <h4 class="text-h4">
                        {{ data.value }}
                      </h4>
                      <div class="text-base" :class="data.change > 0 ? 'text-success' : 'text-error'">
                        ({{ prefixWithPlus(data.change) }}%)
                      </div>
                    </div>
                    <div class="text-sm">
                      {{ data.desc }}
                    </div>
                  </div>
                  <VAvatar :color="data.iconColor" variant="tonal" rounded size="42">
                    <VIcon :icon="data.icon" size="26" />
                  </VAvatar>
                </div>
              </VCardText>
            </VCard>
          </VCol>
        </template>
      </VRow>
    </div> -->
    <AdvancedDatabaseManager></AdvancedDatabaseManager>
  </section>
</template>
